module.exports = __webpack_public_path__ + "img/filter-white-disable.24b53dac.svg";